<template>
	<div class="login bg-blur">
		<!-- 登录 -->
		<div class="login-center">
			<el-row>
				<el-col :span="24" class="tit">颐倍康开放平台管理系统</el-col>
			</el-row>
			<div class="login-form">
				<div class="login-form-contain">
					<div class="login-image">
						<img src="../../public/images/logo.png" alt="">
					</div>
					<el-form :model="form" class="demo-ruleForm contain">
						<el-form-item prop="username">
							<el-input prefix-icon="el-icon-user" type="username" v-model="form.username" placeholder="请输入用户名" @keyup.enter.native="onSubmit()"></el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="form.password" placeholder="请输入密码" @keyup.enter.native="onSubmit()"></el-input>
						</el-form-item>
						<el-checkbox v-model="form.checked" class="rememberme">记住密码(7天)</el-checkbox>
						<el-form-item>
							<el-button type="primary" style="width:100%;font-size:18px;" @click="onSubmit">登录</el-button>
						</el-form-item>
					</el-form>
					<p class="regist not-select">没有用户，马上 <span @click="regist">注册</span></p>
				</div>
			</div>
			<el-row class="copy">
				<el-col :span="24">&copy;颐倍康养老服务有限公司</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import md5 from "js-md5";
// import {
// 		getLogin
// 	} from "@/api"
	export default {

		data() {
			return {
				form: {
					username: "",
					password: "",
					checked: false,
				},


			}
		},
		//页面加载调用获取cookie值
		mounted() {
			this.getCookie();
		},
		methods: {
			regist() {
				this.$router.push("/register")
			},

			onSubmit() {
				// const parameter = {
				// 	username: this.form.username,
				// 	password: md5(this.form.password)
				// }
				
				// getLogin(parameter)
				const data = {
					username: this.form.username,
					password: md5(this.form.password)
				}
				this.$post("api/getToken", data).then(res => {
					var message = res.message
					this.$message({
						message: message,
						type: "success"
					});
					if (message == "登录成功") {
						let token = res.data.token
						window.localStorage.setItem('token',token)
						window.sessionStorage.setItem("loginUser", this.form.username)
						window.sessionStorage.setItem("roleId", res.data.roleId)
						this.$router.push("/")
					}
				})
				
				if (this.form.checked == true) { //记住密码
					// window.console.log("checked==true")
					this.setCookie(this.form.username, this.form.password, 7);
				} else {
					// window.console.log("清空cookie")
					this.clearCookie()
				}
			},
			//设置cookie
			setCookie(c_name, c_pwd, exdays) {
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存天数
				window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			//读取cookie
			getCookie() {
				if (document.cookie.length > 0) {
					var arr = document.cookie.split('; ');
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split('='); //再次切割
						if (arr2[0] == "userName") {
							this.form.username = arr2[1]; //保存到保存数据的地方
						} else if (arr2[0] == "userPwd") {
							this.form.password = arr2[1]
						}
					}
				}
			},
			clearCookie() {
				this.setCookie("", "", -1)
			},



		}
	}
</script>

<style scoped="scoped">
	.login {
		height: 100vh;
		position: relative;
		background: #eee;
		background: url("../../public/images/back1.jpg") no-repeat;
		background-size: 100% 100%;
	}

	.login-center {
		width: 36vw;
		height: 540px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.login-form {
		width: 24vw;
		height: 360px;
		padding: 10px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 10px;
		display: flex;
		overflow: hidden;
		background: rgba(255, 255, 255, 0.3);
		/* margin:200px auto; */
	}



	.login-form-contain {
		width: 100%;
		height: 100%;
		border-radius: 10px;
		background: #fff;
	}

	.tit {
		text-align: center;
		padding: 10px 0;
		color: #fff;
		font-size: 42px;
		font-family: "NSimSun";
	}

	.login-image {
		margin: 2px auto;
		width: 90px;
		height: 90px;
	}

	.login-image img {
		width: 100%;
		height: 100%;
	}

	.copy {
		position: absolute;
		bottom: 36px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 16px;
		color: #fff;
	}

	.regist {
		position: absolute;
		bottom: 22px;
		left: 36px;
		/* right: 240px; */
		font-size: 14px;
	}

	.regist-copy {
		position: absolute;
		bottom: 14px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 16px;
		color: #fff;
	}

	.regist span {
		color: #05abf8;
		cursor: pointer;
	}

	.login-form .demo-ruleForm {
		width: 90%;
		margin: 20px auto;
		background: #fff;
		position: relative;
	}

	.el-form-item .el-input {
		width: 100%;
		font-size: 16px;
	}


	label.el-checkbox.rememberme {
		margin: 0px 0px 15px;
		text-align: left;
	}

	.not-select {
		/*禁止文本被选中*/
		-moz-user-select: none;
		/*火狐*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-ms-user-select: none;
		/*IE10*/
		-khtml-user-select: none;
		/*早期浏览器*/
		user-select: none;
	}
</style>
